import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoSectionContainer, showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import icExcel from '../../../assets/svg/microsoft-excel.svg'
import icPdf from '../../../assets/svg/pdf.svg'
import {ReportBox, ReportsItemTypes} from "../../../raikoComponents/reportBox/ReportBox";
import {useParams} from "react-router-dom";
import {GroupsService} from "../../../serverService/groups/GroupsService";
import {useAuthState} from "../../../context/AuthContext";
import {doDownloadFile} from "../../../util/DownloadHelper";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function GroupDetailReport({groupName}) {

    const {id: groupId} = useParams()

    const service = new GroupsService()
    const {fundID} = useAuthState()

    const loading = new LoadingHelper(useLoadingDispatcher())

    function getReport(type) {
        loading.show()
        service.getGroupReport(groupId, fundID, type)
            .then(response => {
                doDownloadFile(response, `گزارش وضعیت گروه ${groupName}`, type)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"گزارش گروه"}
                >
                    <RaikoGridTwoColumn>

                        <ReportBox
                            label={"EXCEL"}
                            icon={icExcel}
                            action={_ => {
                                getReport(ReportsItemTypes.XLSX.id);
                            }}
                        />

                        <ReportBox
                            label={"PDF"}
                            icon={icPdf}
                            action={_ => {
                                getReport(ReportsItemTypes.PDF.id);
                            }}
                        />
                    </RaikoGridTwoColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </RaikoGridOneColumn>
    )
}
